/**
 * Builder configuration
 *
 * Defines the username and password to use for accessing the Shopify API
 *
 * You may want to consider doing a process.env.NODE_ENV ternary for these
 * exports so you can silently manage doing production deployments
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */

export const API_USERNAME = '';
export const API_PASSWORD = '';
